module.exports = __webpack_public_path__ + "static/img/alchemy-logo-dark.c450626.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/alchemy-logo-dark.png
// module id = f2LY
// module chunks = 2